import { render } from "./QingFooter.vue?vue&type=template&id=16658c7f&scoped=true"
import script from "./QingFooter.vue?vue&type=script&lang=js"
export * from "./QingFooter.vue?vue&type=script&lang=js"

import "./QingFooter.vue?vue&type=style&index=0&id=16658c7f&scoped=true&lang=less"

import exportComponent from "E:\\program\\qingzhui-project\\lastest\\qingzhui-www-web-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16658c7f"]])

export default __exports__